webpackJsonp([23],{

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_role_access_vue__ = __webpack_require__(799);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05aa35a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_role_access_vue__ = __webpack_require__(979);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_role_access_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05aa35a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_role_access_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(544));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(543));

var _alphaNum = _interopRequireDefault(__webpack_require__(546));

var _numeric = _interopRequireDefault(__webpack_require__(547));

var _between = _interopRequireDefault(__webpack_require__(548));

var _email = _interopRequireDefault(__webpack_require__(549));

var _ipAddress = _interopRequireDefault(__webpack_require__(550));

var _macAddress = _interopRequireDefault(__webpack_require__(551));

var _maxLength = _interopRequireDefault(__webpack_require__(552));

var _minLength = _interopRequireDefault(__webpack_require__(553));

var _required = _interopRequireDefault(__webpack_require__(554));

var _requiredIf = _interopRequireDefault(__webpack_require__(555));

var _requiredUnless = _interopRequireDefault(__webpack_require__(556));

var _sameAs = _interopRequireDefault(__webpack_require__(557));

var _url = _interopRequireDefault(__webpack_require__(558));

var _or = _interopRequireDefault(__webpack_require__(559));

var _and = _interopRequireDefault(__webpack_require__(560));

var _not = _interopRequireDefault(__webpack_require__(561));

var _minValue = _interopRequireDefault(__webpack_require__(562));

var _maxValue = _interopRequireDefault(__webpack_require__(563));

var _integer = _interopRequireDefault(__webpack_require__(564));

var _decimal = _interopRequireDefault(__webpack_require__(565));

var helpers = _interopRequireWildcard(__webpack_require__(541));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'undefined',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://acl-dev.casamarketapp.com/api',"SALES_URL":'https://sales.apprunn.net',"ACL_URL_COMPANY":'https://midecommerce.casamarketapp.com',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://s3.amazonaws.com/apprunn-acl/bg-login.jpg',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(545).withParams : __webpack_require__(152).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_six_four__);



var getFile = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fileInfo) {
		var _this = this;

		var newFile, words, lastItem, extension, _ref2, response, newImage;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.isLoadingImage = true;
						newFile = {
							name: fileInfo.name.replace(/\s/g, '-'),
							type: fileInfo.type,
							image: fileInfo.sixFour
						};
						_context.prev = 2;
						words = newFile.name.split('.');
						lastItem = words.length;
						extension = words[lastItem - 1];

						if (!(this.allowedFiles.indexOf(extension) > -1)) {
							_context.next = 14;
							break;
						}

						_context.next = 9;
						return this.$http.post('image/one-upload', newFile);

					case 9:
						_ref2 = _context.sent;
						response = _ref2.data;

						if (extension === 'pdf') {
							this.$emit('send-file', { file: response.data.url_image });
							this.isLoadingImage = false;
						} else {
							newImage = new Image();

							newImage.onload = function () {
								if (newImage.naturalWidth <= _this.allowedMaxSize) {
									var model = {
										urlImage: response.data.url_image
									};
									if (_this.itemUpdate) {
										model.item = _this.itemUpdate;
									}
									_this.$emit('send-image', model);
									_this.isLoadingImage = false;
								} else {
									_this.showNotification('El tama\xF1o m\xE1ximo permitido es ' + _this.allowedMaxSize + ' x ' + _this.allowedMaxSize, 'warning');
									_this.isLoadingImage = false;
								}
							};
							newImage.src = response.data.url_image;
						}
						_context.next = 15;
						break;

					case 14:
						this.showNotification('Archivo no v\xE1lido, solo se permite ' + this.allowedFiles.join(','), 'warning');

					case 15:
						_context.next = 20;
						break;

					case 17:
						_context.prev = 17;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 20:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 17]]);
	}));

	return function getFile(_x) {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function actionUploadImage() {
	this.$refs[this.labelRef].click();
}

function data() {
	return {
		allowedFiles: ['jpg', 'jpeg', 'png', 'svg', 'pdf'],
		isLoadingImage: false,
		newImage: ''
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'upload-image',
	components: {
		VueSixFour: __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default.a
	},
	data: data,
	methods: {
		actionUploadImage: actionUploadImage,
		getFile: getFile
	},
	props: {
		allowedMaxSize: {
			type: Number,
			default: 25
		},
		buttonTitle: {
			default: 'Cambiar de icono',
			type: String
		},
		inputId: {
			type: [Number, String]
		},
		itemUpdate: {
			type: Object,
			default: function _default() {}
		},
		labelFor: {
			type: [Number, String]
		},
		labelRef: {
			type: [Number, String]
		}
	}
});

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),o=n(5),i=n(2),l=i(r.a,o.a,!1,null,null,null);t.default=l.exports},function(e,t){e.exports=function(e,t,n,r,o,i){var l,u=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(l=e,u=e.default);var a="function"==typeof u?u.options:u;t&&(a.render=t.render,a.staticRenderFns=t.staticRenderFns,a._compiled=!0),n&&(a.functional=!0),o&&(a._scopeId=o);var c;if(i?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},a._ssrRegister=c):r&&(c=r),c){var f=a.functional,p=f?a.render:a.beforeCreate;f?(a._injectStyles=c,a.render=function(e,t){return c.call(t),p(e,t)}):a.beforeCreate=p?[].concat(p,c):[c]}return{esModule:l,exports:u,options:a}}},function(e,t,n){"use strict";function r(){return{multipleFiles:[]}}function o(e){for(var t=this,n=e.target.files,r=n.length,o=0;o<r;o+=1)(function(e){var o=n[e],i=new FileReader;i.readAsDataURL(o),i.addEventListener("load",function(){var e=l()(o,{sixFour:i.result});t.multipleFiles.push(e),r===t.multipleFiles.length&&(t.$emit("vue-six-four",t.allowMultiple?t.multipleFiles:t.multipleFiles[0]),t.multipleFiles=[]),i=null})})(o)}var i=n(4),l=n.n(i);t.a={data:r,name:"vue-six-four",methods:{readFile:o},props:{allowMultiple:{type:Boolean,default:!1}}}},function(e,t){e.exports=__webpack_require__(46)},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{attrs:{type:"file",multiple:e.allowMultiple},on:{change:e.readFile}})},o=[],i={render:r,staticRenderFns:o};t.a=i}]);

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__ = __webpack_require__(590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e152234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e152234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{ref:_vm.labelRef,attrs:{"for":_vm.labelFor}},[_c('vue-six-four',{attrs:{"id":_vm.inputId,"hidden":""},on:{"vue-six-four":_vm.getFile}}),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary"},on:{"click":_vm.actionUploadImage}},[_vm._v("\n\t\t\t"+_vm._s(_vm.buttonTitle)+"\n\t\t")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_roles_role_access_configuration__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_roles_role_access_module_form__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_roles_role_access_resource_list__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_roles_role_access_subresource_form__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_roles_role_access_action__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_roles_role_access_services__ = __webpack_require__(977);





var assignSubresources = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
		var subresources = _ref2.subresources,
		    resourceId = _ref2.resourceId;
		var headers, body;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						body = {
							id: resourceId,
							resourcesId: subresources.map(function (_ref3) {
								var id = _ref3.id,
								    isSelected = _ref3.isSelected;
								return { id: id, isSelected: isSelected };
							})
						};

						this.subresourceLoading = true;
						_context.prev = 3;
						_context.next = 6;
						return this.$http.post('resources-levels', body, { headers: headers });

					case 6:
						this.showNotification('Los subrecursos han sido asignados correctamente.');
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](3);

						if (_context.t0.status === 500) {
							this.showError();
						} else if (_context.t0.status === 400) {
							if (_context.t0.data.resourcesId) {
								this.showNotification('La lista de recursos es requerida.', 'error');
							}
						}

					case 12:
						_context.prev = 12;

						this.subresourceLoading = false;
						return _context.finish(12);

					case 15:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 9, 12, 15]]);
	}));

	return function assignSubresources(_x) {
		return _ref.apply(this, arguments);
	};
}();

var listModules = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, headers, response;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							page: 1,
							perPage: 30,
							codeApp: this.codeApp,
							roleId: this.roleId
						};
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context2.next = 4;
						return this.$http.get('project/' + this.codeProject + '/company/' + this.codeCompany + '/modules', { params: params, headers: headers });

					case 4:
						response = _context2.sent;

						this.chips = response.data.data;
						this.resourcesDelete = [];
						this.loadResource();

					case 8:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function listModules() {
		return _ref4.apply(this, arguments);
	};
}();

var loadApps = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var headers, _ref6, apps;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context3.next = 3;
						return this.$http.get('project/' + this.codeProject + '/company/' + this.codeCompany + '/apps', { headers: headers });

					case 3:
						_ref6 = _context3.sent;
						apps = _ref6.data;

						this.apps = apps.data;

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadApps() {
		return _ref5.apply(this, arguments);
	};
}();

var loadResource = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var _this2 = this;

		var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		var arraySelect, params, headers, _ref8, rows;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						arraySelect = [];

						this.chips.forEach(function (element) {
							arraySelect.push(element.id);
						});
						params = {
							modulesId: arraySelect.join(),
							roleId: this.roleId,
							search: value || null
						};
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};

						this.loading = true;

						if (!(this.chips.length > 0)) {
							_context4.next = 25;
							break;
						}

						_context4.prev = 6;
						_context4.next = 9;
						return this.$http.get('resources-permission', { params: params, headers: headers });

					case 9:
						_ref8 = _context4.sent;
						rows = _ref8.data;

						this.rows = rows.data.map(function (element) {
							var newElement = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, element);
							newElement.statusName = element.status ? 'Agregado' : 'No Agregado';
							newElement.configLanguages = element.configLanguages ? element.configLanguages : '';
							newElement.resource = element.resource ? element.resource.data.name : '';
							newElement.module = element.module ? element.module.data.name : '';
							newElement.disabled = !newElement.configLanguages;
							newElement.isSelected = _this2.checkAll ? newElement.status > 0 : _this2.checkRow;
							newElement.configPosition = element.configLanguages ? element.configLanguages.position : null;
							return newElement;
						});
						this.checkAll = this.rows.some(function (element) {
							return element.status === 1;
						});
						this.allIsSelected(this.checkAll);
						_context4.next = 19;
						break;

					case 16:
						_context4.prev = 16;
						_context4.t0 = _context4['catch'](6);

						this.showError();

					case 19:
						_context4.prev = 19;

						this.loading = false;
						this.modulesId = params.modulesId;
						return _context4.finish(19);

					case 23:
						_context4.next = 27;
						break;

					case 25:
						this.loading = false;
						this.rows = [];

					case 27:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[6, 16, 19, 23]]);
	}));

	return function loadResource() {
		return _ref7.apply(this, arguments);
	};
}();

var saveRole = function () {
	var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var resources, headers;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						resources = this.rows.map(function (element) {
							var newSelect = {};
							newSelect.id = element.id;
							newSelect.isSelected = element.isSelected;
							newSelect.permission = element.permission || {};
							return newSelect;
						});

						this.resourcesDelete.forEach(function (element) {
							var newSelect = {};
							newSelect.id = element;
							newSelect.isSelected = false;
							resources.push(newSelect);
						});
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};

						this.assignLoading = true;
						_context5.prev = 4;
						_context5.next = 7;
						return this.$http.post('role/' + this.roleId + '/resource', { resources: resources }, { headers: headers });

					case 7:
						this.showNotification('Los permisos han sido asignados correctamente.');
						this.loadResource();
						_context5.next = 14;
						break;

					case 11:
						_context5.prev = 11;
						_context5.t0 = _context5['catch'](4);

						this.showError();

					case 14:
						_context5.prev = 14;

						this.assignLoading = false;
						return _context5.finish(14);

					case 17:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[4, 11, 14, 17]]);
	}));

	return function saveRole() {
		return _ref10.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









function created() {
	this.loadApps();
}

function actionModules() {
	return this.action.code === 'MOD';
}

function actionSettings() {
	return this.action.code === 'SETTINGS';
}

function actionSubresources() {
	return this.action.code === 'SRC';
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.resources = [];
	this.rows = this.selectIsRow(this.rows, 'isSelected', false, checked, 'status');
}

function closeModal() {
	if (this.action.code === 'ASSIGN-SERVICES') {
		this.closeModalServices();
	} else {
		this.action.code = '';
		this.action.value = false;
		this.action.title = '';
		this.loadResource();
	}
}

function deleteResource(idSelect, nameSelect) {
	var _this = this;

	this.resourcesDelete = this.rows.filter(function (element) {
		return element.module === nameSelect && element.status === 1;
	});
	this.resourcesDelete = this.resourcesDelete.map(function (element) {
		return element.id;
	});
	this.chips.forEach(function (element, index) {
		if (element.id === idSelect) {
			_this.chips.splice(index, 1);
			_this.loadResource();
		}
	});
}

function disabledSave() {
	return this.rows.length === 0 || this.assignLoading;
}

function onSearch(value) {
	this.params.code = value;
	this.loadData('app/' + this.codeApp + '/modules');
}

function openModal() {
	this.action.code = 'MOD';
	this.action.value = true;
	this.action.title = 'MÓDULOS';
}

function openSettings(id) {
	var _this3 = this;

	this.id = id;
	this.rows.forEach(function (element) {
		if (element.id === id) {
			_this3.rowSelect = element;
		}
	});
	this.action.code = 'SETTINGS';
	this.action.value = true;
	this.action.title = 'Configuración';
}

function openSubresources(_ref9) {
	var id = _ref9.id,
	    name = _ref9.name;

	this.resourceId = id;
	this.resourceName = name;
	this.action.code = 'SRC';
	this.action.title = 'SUB RECURSOS';
	this.action.value = true;
}

function rowIsSelected(row) {
	this.checkRow = row.isSelected;
	this.rows = this.selectIsRow(this.rows, 'isSelected', row);
	this.checkAll = this.every(this.rows.filter(function (element) {
		return element.status === 1;
	}));
}

function showSelection(modules) {
	this.chips = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], modules);
	this.loadResource();
}

function cancel() {
	this.goTo('page-role');
}

function onSearchResource(value) {
	this.loadResource(value);
}

function actionAssignActionBar() {
	return this.action.code === 'ASSIGN-ACTION-BAR';
}

function openActions(_ref11) {
	var id = _ref11.id,
	    name = _ref11.name;

	this.resourceId = id;
	this.resourceName = name;
	this.action.code = 'ASSIGN-ACTION-BAR';
	this.action.title = 'ASIGNAR BARRA DE ACCIONES';
	this.action.value = true;
}

function openServices(_ref12) {
	var id = _ref12.id,
	    name = _ref12.name,
	    permission = _ref12.permission;

	this.resourceId = id;
	this.resourceName = name;
	this.resourcePermission = permission || {};
	this.action.code = 'ASSIGN-SERVICES';
	this.action.title = 'ASIGNAR SERVICIOS';
	this.action.value = true;
}

function actionServices() {
	return this.action.code === 'ASSIGN-SERVICES';
}

function saveServices(services, id) {
	var index = this.rows.findIndex(function (r) {
		return r.id === id;
	});
	if (index > -1) {
		var selects = services.filter(function (s) {
			return s.isSelected;
		});
		if (selects.length) {
			this.rows[index].permission = selects.reduce(function (acum, item) {
				var newAcum = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, acum);
				newAcum[item.id] = item.authorize;
				return newAcum;
			}, {});
		} else {
			this.rows[index].permission = {};
		}
	}
	this.showNotification('Los servicios han sido asignados correctamente.');
	this.closeModalServices();
}

function closeModalServices() {
	this.action.code = '';
	this.action.value = false;
	this.action.title = '';
}

function data() {
	return {
		action: {
			code: '',
			title: '',
			value: false
		},
		apps: [],
		assignLoading: false,
		checkAll: false,
		checkRow: false,
		chips: [],
		codeApp: '',
		columns: [{ id: 1, name: 'Nombre', checked: true, visible: true }, { id: 2, name: 'URL', checked: true, visible: true }, { id: 3, name: 'Recurso Padre', checked: true, visible: true }, { id: 4, name: 'Módulo', checked: true, visible: true }, { id: 5, name: 'Posición', checked: true, visible: true }, { id: 6, name: 'Estado', checked: true, visible: true }, { id: 7, name: 'Acciones', checked: true, visible: true, flagVisible: true }],
		currentPage: 1,
		id: 0,
		isSelected: 1,
		loading: false,
		modulesId: '',
		resourceId: 0,
		resourceName: '',
		resourcePermission: {},
		rows: [],
		resourcesDelete: [],
		rowSelect: {},
		subresourceLoading: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-access-role',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__["default"],
		roleAccessConfiguration: __WEBPACK_IMPORTED_MODULE_5__components_roles_role_access_configuration__["a" /* default */],
		roleAccessModuleForm: __WEBPACK_IMPORTED_MODULE_6__components_roles_role_access_module_form__["a" /* default */],
		roleAccessResourceList: __WEBPACK_IMPORTED_MODULE_7__components_roles_role_access_resource_list__["a" /* default */],
		roleAccessSubresourceForm: __WEBPACK_IMPORTED_MODULE_8__components_roles_role_access_subresource_form__["a" /* default */],
		roleAccessAction: __WEBPACK_IMPORTED_MODULE_9__components_roles_role_access_action__["a" /* default */],
		roleAccessServices: __WEBPACK_IMPORTED_MODULE_10__components_roles_role_access_services__["a" /* default */]
	},
	computed: {
		actionAssignActionBar: actionAssignActionBar,
		actionModules: actionModules,
		actionSettings: actionSettings,
		actionSubresources: actionSubresources,
		actionServices: actionServices,
		disabledSave: disabledSave
	},
	created: created,
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		assignSubresources: assignSubresources,
		cancel: cancel,
		closeModal: closeModal,
		deleteResource: deleteResource,
		listModules: listModules,
		loadApps: loadApps,
		loadResource: loadResource,
		onSearch: onSearch,
		onSearchResource: onSearchResource,
		openActions: openActions,
		openModal: openModal,
		openServices: openServices,
		openSettings: openSettings,
		openSubresources: openSubresources,
		rowIsSelected: rowIsSelected,
		saveRole: saveRole,
		showSelection: showSelection,
		saveServices: saveServices,
		closeModalServices: closeModalServices
	},
	props: {
		codeCompany: {
			type: String
		},
		roleId: {
			type: [Number, String]
		},
		roleName: {
			type: String
		},
		codeProject: {
			type: String
		}
	}
});

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_upload_image__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);




var submitForm = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var body, headers;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						body = {
							id: this.id,
							languages: this.languages,
							position: this.model.position,
							pathIcon: this.model.pathIcon
						};
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};

						this.loading = true;
						_context.prev = 3;
						_context.next = 6;
						return this.$http.post('project/' + this.codeProject + '/company/' + this.codeCompany + '/resources', body, { headers: headers });

					case 6:
						this.showNotification('Se configuro correctamente.');
						this.closeModal();
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](3);

						this.showError();

					case 13:
						_context.prev = 13;

						this.loading = false;
						return _context.finish(13);

					case 16:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 10, 13, 16]]);
	}));

	return function submitForm() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function closeModal() {
	this.$emit('close-modal');
}

function created() {
	var _this = this;

	var languagesKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.languages);
	languagesKeys.forEach(function (key) {
		if (_this.rows.configLanguages) {
			if (_this.rows.configLanguages.languages) {
				_this.languages[key].name = _this.rows.configLanguages.languages[key].name;
			} else {
				_this.languages[key].name = '';
			}
		} else {
			_this.languages[key].name = '';
		}
	});
	this.model.position = this.rows.configLanguages ? this.rows.configLanguages.position : '';
	this.model.pathIcon = this.rows.configLanguages ? this.rows.configLanguages.pathIcon : this.rows.pathIcon;
}

function sendImage(_ref) {
	var urlImage = _ref.urlImage;

	this.model.pathIcon = urlImage;
}

function disabled() {
	var _this2 = this;

	var languagesKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.languages);
	return !languagesKeys.some(function (key) {
		return _this2.languages[key].name.trim() && !_this2.$v.$invalid;
	}) || this.loading;
}

function validations() {
	var validation = {
		model: {
			position: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
				numeric: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["numeric"]
			},
			pathIcon: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
			}
		}
	};
	return validation;
}

function data() {
	return {
		allowedFiles: ['jpg', 'jpeg', 'png', 'svg'],
		isLoadingImage: false,
		loading: false,
		model: {
			position: '',
			pathIcon: ''
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-configuration',
	data: data,
	created: created,
	computed: {
		disabled: disabled
	},
	components: {
		uploadImage: __WEBPACK_IMPORTED_MODULE_3__components_shared_upload_image__["a" /* default */]
	},
	methods: {
		closeModal: closeModal,
		submitForm: submitForm,
		sendImage: sendImage
	},
	props: {
		codeCompany: {
			type: String
		},
		codeProject: {
			type: String
		},
		id: {
			type: Number
		},
		rows: {
			type: Object
		}
	},
	validations: validations
});

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__role_access_module_list__ = __webpack_require__(964);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (this.isSelected === 1) {
							this.params.isSelected = this.isSelected;
						}
						this.params.codeApp = this.codeApp;
						this.params.roleId = this.roleId;
						this.loadData('project/' + this.codeProject + '/company/' + this.codeCompany + '/modules');

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function disabled() {
	return !this.table.rows.some(function (element) {
		return element.isSelected;
	}) || this.loading;
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', false, checked);
}

function closeModal() {
	this.$emit('close-modal');
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', row);
	this.checkAll = this.every(this.table.rows);
}

function submitForm() {
	this.closeModal();
	this.modulesSelected = this.table.rows.filter(function (element) {
		return element.isSelected;
	});
	this.$emit('save-selection', this.modulesSelected);
}

function data() {
	return {
		columns: [{ id: 1, name: 'Nombre', checked: true, visible: true }],
		checkAll: false,
		modulesSelected: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-module-form',
	components: {
		roleAccessModuleList: __WEBPACK_IMPORTED_MODULE_2__role_access_module_list__["a" /* default */]
	},
	computed: {
		disabled: disabled
	},
	created: created,
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		closeModal: closeModal,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected,
		submitForm: submitForm
	},
	props: {
		codeApp: {
			type: String
		},
		codeCompany: {
			type: String
		},
		isSelected: {
			type: Number
		},
		loading: {
			default: false,
			type: Boolean
		},
		roleName: {
			type: String
		},
		roleId: {
			type: [Number, String]
		},
		codeProject: {
			type: String
		}
	}
});

/***/ }),

/***/ 802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-module-list',
	props: {
		codeCompany: {
			type: String
		},
		codeProject: {
			type: String
		},
		columns: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 0
		},
		checkAll: {
			default: false,
			type: Boolean
		},
		lastPage: {
			type: Number,
			default: 0
		},
		rows: {
			type: Array,
			required: true
		}
	},
	methods: {
		allIsSelected: allIsSelected,
		changePage: changePage,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	}
});

/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(150);



var updatePosition = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref3) {
		var id = _ref3.id,
		    configPosition = _ref3.configPosition;
		var position, headers;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						position = configPosition;
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context.prev = 2;
						_context.next = 5;
						return this.$http.post('project/' + this.codeProject + '/company/' + this.codeCompany + '/resources', { id: id, position: position }, { headers: headers });

					case 5:
						this.showNotification('La posición ha sido cambiada correctamente.');
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 8]]);
	}));

	return function updatePosition(_x) {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function allIsSelected(checked) {
	this.$emit('all-is-selected', checked);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openSettings(value) {
	this.$emit('open-settings', value);
}

function openSubresources(row) {
	this.$emit('open-subresources', row);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function disabledInput(_ref) {
	var configLanguages = _ref.configLanguages;

	return !configLanguages;
}

function openActions(value) {
	this.$emit('open-actions', value);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-resource-list',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	props: {
		codeCompany: {
			type: String
		},
		codeProject: {
			type: String
		},
		columns: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 0
		},
		rows: {
			type: Array,
			required: true
		},
		checkAll: {
			default: false,
			type: Boolean
		},
		checkRow: {
			default: false,
			type: Boolean
		}
	},
	methods: {
		allIsSelected: allIsSelected,
		disabledInput: disabledInput,
		onSearch: onSearch,
		openSettings: openSettings,
		openSubresources: openSubresources,
		openActions: openActions,
		rowIsSelected: rowIsSelected,
		updatePosition: updatePosition
	}
});

/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__role_access_subresource_list__ = __webpack_require__(970);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.params.flagLevels = this.flagLevels;
						this.params.modulesId = this.modulesId;
						this.params.resourceId = this.resourceId;
						this.loadData('resources-permission');

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function allIsSelected(checked) {
	this.checkAll = checked;
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', false, checked);
	this.setDataSelected();
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData('resources-permission');
}

function closeModal() {
	this.$emit('close-modal');
}

function rowIsSelected(row) {
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', row);
	this.checkAll = this.every(this.table.rows);
	this.setDataSelected(row);
}

function setDataSelected(row) {
	var _this = this;

	if (!row) {
		if (this.checkAll) {
			this.table.rows.forEach(function (rowData) {
				var index = _this.dataSelected.findIndex(function (d) {
					return d.id === rowData.id;
				});
				if (index < 0) {
					_this.dataSelected.push(rowData);
				}
			});
		} else {
			this.table.rows.forEach(function (rowData) {
				var index = _this.dataSelected.findIndex(function (d) {
					return d.id === rowData.id;
				});
				if (index >= 0) {
					_this.dataSelected.splice(index, 1);
				}
			});
		}
	} else {
		var index = this.dataSelected.findIndex(function (d) {
			return d.id === row.id;
		});
		if (index < 0) {
			this.dataSelected.push(row);
		} else {
			this.dataSelected.splice(index, 1);
		}
	}
}

function submitForm() {
	this.closeModal();
	var model = {
		subresources: this.table.rows,
		resourceId: this.resourceId
	};
	this.$emit('send-selection', model);
}

function data() {
	return {
		checkAll: false,
		columns: [{ id: 1, name: 'Nombre', checked: true, visible: true }],
		currentPage: 1,
		dataSelected: [],
		flagLevels: 1
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-subresource-form',
	components: {
		roleAccessSubresourceList: __WEBPACK_IMPORTED_MODULE_2__role_access_subresource_list__["a" /* default */]
	},
	created: created,
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		changePage: changePage,
		closeModal: closeModal,
		rowIsSelected: rowIsSelected,
		setDataSelected: setDataSelected,
		submitForm: submitForm
	},
	props: {
		loading: {
			default: false,
			type: Boolean
		},
		modulesId: {
			type: String
		},
		resourceId: {
			type: [Number, String]
		},
		resourceName: {
			type: String
		}
	}
});

/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function allIsSelected(checked) {
	this.$emit('all-is-selected', checked);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-subresource-list',
	props: {
		columns: {
			type: Array,
			required: true
		},
		checkAll: {
			default: false,
			type: Boolean
		},
		currentPage: {
			type: Number,
			default: 0
		},
		lastPage: {
			type: Number,
			default: 0
		},
		rows: {
			type: Array,
			required: true
		}
	},
	methods: {
		allIsSelected: allIsSelected,
		changePage: changePage,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	}
});

/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_roles_role_access_action_list__ = __webpack_require__(974);





var loadActions = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var params, headers, _ref2, actions;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = this.actionParams;
						headers = this.version;
						_context.prev = 2;
						_context.next = 5;
						return this.$http.get('action-list', { params: params, headers: headers });

					case 5:
						_ref2 = _context.sent;
						actions = _ref2.data;

						this.actions = actions.data.map(function (action) {
							var newAction = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, action);
							var keyLanguages = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(action.languages);
							var firstLanguages = keyLanguages[0];
							newAction[_this.selectedValue] = action[_this.selectedValue] === 1;
							newAction.name = action.languages.es ? action.languages.es.name : action.languages[firstLanguages].name;
							return newAction;
						});
						this.checkAll = this.every(this.actions, this.selectedValue);
						_context.next = 14;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 11]]);
	}));

	return function loadActions() {
		return _ref.apply(this, arguments);
	};
}();

var submitForm = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var actionsArray, headers, params;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						actionsArray = this.actions.map(function (_ref4) {
							var id = _ref4.id,
							    flagSelected = _ref4.flagSelected;
							return { id: id, flagSelected: flagSelected };
						});
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						params = {
							actions: actionsArray,
							roleId: Number(this.roleId)
						};

						this.loading = true;
						_context2.prev = 4;
						_context2.next = 7;
						return this.$http.post('resource/' + this.resourceId + '/actions', params, { headers: headers });

					case 7:
						this.showNotification('La barra de acciones ha sido asignada correctamente');

					case 8:
						_context2.prev = 8;

						this.loading = false;
						return _context2.finish(8);

					case 11:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[4,, 8, 11]]);
	}));

	return function submitForm() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.actionParams.codeProject = this.codeProject;
	this.actionParams.resourceId = this.resourceId;
	this.actionParams.roleId = this.roleId;
	this.loadActions();
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.actions = this.selectIsRow(this.actions, this.selectedValue, false, checked);
}

function onSearchList(value) {
	this.actionParams.search = value;
	this.loadActions();
}

function rowIsSelected(row) {
	this.actions = this.selectIsRow(this.actions, this.selectedValue, row);
	this.checkAll = this.every(this.actions, this.selectedValue);
}

function closeModal() {
	this.$emit('close-modal');
}

function data() {
	return {
		actionParams: {
			codeProject: '',
			resourceId: 0
		},
		actions: [],
		checkAll: false,
		columns: [{ id: 1, name: 'Nombre', checked: true, visible: true }, { id: 2, name: 'Código', checked: true, visible: true }, { id: 3, name: 'Url Web', checked: true, visible: true }, { id: 4, name: 'Fragment Móvil', checked: true, visible: true }],
		loading: false,
		selectedValue: 'flagSelected',
		version: {
			Accept: '' + 'application/vnd.apiacl.v2+json'
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-action',
	components: {
		roleAccessActionList: __WEBPACK_IMPORTED_MODULE_4__components_roles_role_access_action_list__["a" /* default */]
	},
	created: created,
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		closeModal: closeModal,
		loadActions: loadActions,
		onSearchList: onSearchList,
		rowIsSelected: rowIsSelected,
		submitForm: submitForm
	},
	props: {
		codeProject: {
			type: String,
			required: true
		},
		resourceId: {
			type: [Number, String],
			required: true
		},
		resourceName: {
			type: String,
			required: true
		},
		roleId: {
			type: [Number, String],
			required: true
		}
	}
});

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'resource-action-list',
	methods: {
		allIsSelected: allIsSelected,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		checkAll: {
			type: Boolean,
			required: true
		},
		columns: {
			type: Array,
			required: true
		},
		rows: {
			type: Array,
			required: true
		},
		selectedValue: {
			type: String,
			required: true
		}
	}
});

/***/ }),

/***/ 808:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var _ref2, response, arrayPermission;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$http.get('web-services', { params: this.params });

					case 3:
						_ref2 = _context.sent;
						response = _ref2.data;
						arrayPermission = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.resourcePermission);

						if (arrayPermission.length) {
							this.services = response.data.map(function (r) {
								var newService = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, r);
								var index = arrayPermission.findIndex(function (a) {
									return Number(a) === r.id;
								});
								newService.isSelected = index > -1 ? true : newService.isSelected;
								newService.authorize = index > -1 ? _this.resourcePermission[r.id] : newService.authorize;
								return newService;
							});
						} else {
							this.services = response.data;
						}
						this.dataSelected = this.services.filter(function (s) {
							return s.isSelected;
						});
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](0);

						this.showError();

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 10]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function closeModal() {
	this.$emit('close-modal');
}

function rowIsSelected(row) {
	this.services = this.selectIsRow(this.services, 'isSelected', row);
	if (row.isSelected) {
		this.dataSelected.push(row);
	} else {
		var index = this.dataSelected.findIndex(function (d) {
			return d.id === row.id;
		});
		this.dataSelected.splice(index, 1);
	}
	this.checkAll = this.services.every(function (s) {
		return s.isSelected;
	});
}

function allIsSelected(value) {
	this.checkAll = value;
	this.services = this.services.map(function (s) {
		var newService = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, s);
		newService.isSelected = value;
		return newService;
	});
}

function saveServices() {
	this.$emit('save-services', this.services, this.resourceId);
}

function created() {
	this.params = {
		resourceId: this.resourceId,
		roleId: this.roleId
	};
	this.loadData();
}

function data() {
	return {
		actionParams: {
			codeProject: '',
			resourceId: 0
		},
		services: [],
		checkAll: false,
		columns: [{ id: 1, name: 'Dominio', checked: true, visible: true }, { id: 2, name: 'Método', checked: true, visible: true }, { id: 3, name: 'URI', checked: true, visible: true }, { id: 4, name: 'Nombre', checked: true, visible: true }, { id: 5, name: 'Auth', checked: true, visible: true }],
		loading: false,
		selectedValue: 'flagSelected',
		version: {
			Accept: '' + 'application/vnd.apiacl.v2+json'
		},
		params: {},
		dataSelected: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'role-access-services',
	data: data,
	created: created,
	methods: {
		allIsSelected: allIsSelected,
		closeModal: closeModal,
		loadData: loadData,
		rowIsSelected: rowIsSelected,
		saveServices: saveServices
	},
	props: {
		resourceId: {
			type: [Number, String],
			required: true
		},
		resourceName: {
			type: String,
			required: true
		},
		roleId: {
			type: [Number, String],
			required: true
		},
		resourcePermission: {
			type: Object,
			default: function _default() {}
		}
	}
});

/***/ }),

/***/ 961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_configuration_vue__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75ea9e99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_configuration_vue__ = __webpack_require__(962);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_configuration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75ea9e99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_configuration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-form',{attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_vm._l((_vm.languages),function(value,key,index){return _c('v-layout',{key:index,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":"","text-xs-left":""}},[_c('v-subheader',{staticClass:"pa-0"},[_vm._v(_vm._s(key))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre"},model:{value:(value.name),callback:function ($$v) {_vm.$set(value, "name", $$v)},expression:"value.name"}})],1)],1)}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Posición","error":_vm.$v.model.position.$error},model:{value:(_vm.$v.model.position.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.position, "$model", $$v)},expression:"$v.model.position.$model"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","align-center":"","px-2":""}},[_c('v-text-field',{staticClass:"body-1 mr-2",attrs:{"solo":"","hide-details":"","error":_vm.$v.model.pathIcon.$error},model:{value:(_vm.$v.model.pathIcon.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.pathIcon, "$model", $$v)},expression:"$v.model.pathIcon.$model"}}),_vm._v(" "),_c('upload-image',{attrs:{"label-ref":"btn-up","label-for":"icon","input-id":"icon"},on:{"send-image":_vm.sendImage}})],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.disabled,"on-run-service":_vm.loading},on:{"cancel-button-clicked":_vm.closeModal,"accept-button-clicked":_vm.submitForm}})],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_module_form_vue__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff10711a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_module_form_vue__ = __webpack_require__(966);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_module_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff10711a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_module_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_module_list_vue__ = __webpack_require__(802);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe4894a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_module_list_vue__ = __webpack_require__(965);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_module_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe4894a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_module_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-table',{staticClass:"mt-3",attrs:{"name":"roles-access-modules","columns":_vm.columns,"check-all":_vm.checkAll,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"rows":_vm.rows,"selectable":""},on:{"on-page":_vm.changePage,"on-search-event":_vm.onSearch,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.row.name))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-form',{attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('role-access-module-list',{attrs:{"columns":_vm.columns,"check-all":_vm.checkAll,"rows":_vm.table.rows,"last-page":_vm.table.lastPage},on:{"all-is-selected":_vm.allIsSelected,"on-search":_vm.onSearch,"row-is-selected":_vm.rowIsSelected}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.disabled,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.submitForm,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_resource_list_vue__ = __webpack_require__(803);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a26f4d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_resource_list_vue__ = __webpack_require__(968);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_resource_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a26f4d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_resource_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-5"},[_c('app-table',{staticClass:"mt-3 table-rows no-main-list",attrs:{"name":"roles-access-resources","columns":_vm.columns,"check-all":_vm.checkAll,"rows":_vm.rows,"main-list":false,"selectable":""},on:{"on-search-event":_vm.onSearch,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.uri)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.resource)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.module)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_c('v-text-field',{staticClass:"body-1 mx-auto input-small mt-2",attrs:{"hide-details":"","min":"0","required":"","small":"","solo":"","type":"number","disabled":_vm.disabledInput(props.row)},on:{"blur":function($event){_vm.updatePosition(props.row)}},model:{value:(props.row.configPosition),callback:function ($$v) {_vm.$set(props.row, "configPosition", _vm._n($$v))},expression:"props.row.configPosition"}})],1),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 6)),expression:"showRow(columns, 6)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.statusName))]),_vm._v(" "),_c('td',[_c('app-tooltip-button',{attrs:{"color":"blue","icon":"settings","text":"Configurar Recurso"},on:{"click-icon":function($event){_vm.openSettings(props.row.id)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"green","icon":"sort","text":"Agregar Subrecursos"},on:{"click-icon":function($event){_vm.openSubresources(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"blue","icon":"touch_app","text":"Barra de Acciones"},on:{"click-icon":function($event){_vm.openActions(props.row)}}}),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","small":""},on:{"click":function($event){_vm.$emit('open-services', props.row)}},slot:"activator"},[_c('img',{attrs:{"src":"https://s3.amazonaws.com/apprunn-acl/icons/53v0AJ79clj62cA8zvhzycXgHFrfdT.png","alt":"servicios","height":"20"}})]),_vm._v(" "),_c('span',[_vm._v("Servicios")])],1)],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_subresource_form_vue__ = __webpack_require__(804);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d69ca0dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_subresource_form_vue__ = __webpack_require__(972);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_subresource_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d69ca0dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_subresource_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_subresource_list_vue__ = __webpack_require__(805);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41cd6bf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_subresource_list_vue__ = __webpack_require__(971);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_subresource_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41cd6bf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_subresource_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-table',{staticClass:"mt-3",attrs:{"name":"roles-access-subresources","columns":_vm.columns,"current-page":_vm.currentPage,"rows":_vm.rows,"check-all":_vm.checkAll,"last-page":_vm.lastPage,"selectable":""},on:{"on-selected-all":_vm.allIsSelected,"on-page":_vm.changePage,"on-search-event":_vm.onSearch,"row-is-selected":_vm.rowIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}]},[_vm._v(_vm._s(props.row.name))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-form',{attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-subheader',{attrs:{"pl-2":""}},[_vm._v("\n\t\t\t\t\tRecurso padre: "+_vm._s(_vm.resourceName)+"\n\t\t\t\t")])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('role-access-subresource-list',{attrs:{"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.table.rows,"last-page":_vm.table.lastPage},on:{"all-is-selected":_vm.allIsSelected,"change-page":_vm.changePage,"on-search":function($event){_vm.onSearch($event, 'resources-permission')},"row-is-selected":_vm.rowIsSelected}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.loading,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.submitForm,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_action_vue__ = __webpack_require__(806);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13407fe0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_action_vue__ = __webpack_require__(976);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_action_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13407fe0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_action_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_action_list_vue__ = __webpack_require__(807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ee5f42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_action_list_vue__ = __webpack_require__(975);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_action_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ee5f42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_action_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-table',{staticClass:"mt-3 no-main-list",attrs:{"name":"role-access-action","selectable":"","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"main-list":false,"rows":_vm.rows},on:{"on-search-event":_vm.onSearch,"on-selected-all":_vm.allIsSelected,"row-is-selected":_vm.rowIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.code)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.codeWeb)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.numFragment)+"\n\t\t\t")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-subheader',[_vm._v("Recurso: "+_vm._s(_vm.resourceName))])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('role-access-action-list',{attrs:{"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.actions,"selected-value":_vm.selectedValue},on:{"all-is-selected":_vm.allIsSelected,"on-search":_vm.onSearchList,"row-is-selected":_vm.rowIsSelected}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.loading,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.submitForm,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_services_vue__ = __webpack_require__(808);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45fef392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_services_vue__ = __webpack_require__(978);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_access_services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45fef392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_access_services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-subheader',[_vm._v("Recurso: "+_vm._s(_vm.resourceName))])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('app-table',{staticClass:"mt-3 table-rows no-main-list",attrs:{"name":"roles-access-resources","columns":_vm.columns,"check-all":_vm.checkAll,"rows":_vm.services,"main-list":false,"selectable":""},on:{"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.domain)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.method)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.path)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_c('v-checkbox',{staticClass:"pl-2",attrs:{"color":"success","hide-details":""},model:{value:(props.row.authorize),callback:function ($$v) {_vm.$set(props.row, "authorize", $$v)},expression:"props.row.authorize"}})],1)]}}])})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.loading,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.saveServices,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-page',{attrs:{"name":"access-by-role","title":_vm.$route.meta.title}}),_vm._v(" "),_c('general-filter',{staticClass:"mt-4"},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs3":"","pr-2":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"codeApp","items":_vm.apps,"label":"Aplicaciones"},on:{"input":_vm.listModules},model:{value:(_vm.codeApp),callback:function ($$v) {_vm.codeApp=$$v},expression:"codeApp"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"success","disabled":!_vm.codeApp},on:{"click":_vm.openModal}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n\t\t\t\t\tMódulos\n\t\t\t\t")],1)],1)],1)],1),_vm._v(" "),_c('general-filter',{staticClass:"mt-4"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.chips),function(chip){return _c('v-chip',{key:chip.id,attrs:{"close":""},on:{"input":function($event){_vm.deleteResource(chip.id, chip.name)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(chip.name)+"\n\t\t\t\t")])}))],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"table-padding",attrs:{"xs12":""}},[_c('role-access-resource-list',{attrs:{"columns":_vm.columns,"check-all":_vm.checkAll,"rows":_vm.rows,"code-company":_vm.codeCompany,"code-project":_vm.codeProject,"check-row":_vm.checkRow},on:{"all-is-selected":_vm.allIsSelected,"on-search":_vm.onSearchResource,"open-settings":_vm.openSettings,"open-actions":_vm.openActions,"open-subresources":_vm.openSubresources,"open-services":_vm.openServices,"row-is-selected":_vm.rowIsSelected}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('section',{staticClass:"modal-filter-footer"},[_c('v-flex',{attrs:{"xs12":""}},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.disabledSave,"on-run-service":_vm.assignLoading},on:{"accept-button-clicked":_vm.saveRole,"cancel-button-clicked":_vm.cancel}})],1)],1)]),_vm._v(" "),_c('action-sidebar',{attrs:{"title":_vm.action.title,"value":_vm.action.value},on:{"close-modal":_vm.closeModal}},[(_vm.actionModules)?_c('role-access-module-form',{attrs:{"code-app":_vm.codeApp,"code-company":_vm.codeCompany,"code-project":_vm.codeProject,"is-selected":_vm.isSelected,"loading":_vm.loading,"role-id":_vm.roleId,"role-name":_vm.roleName},on:{"on-search":_vm.onSearch,"save-selection":_vm.showSelection,"close-modal":_vm.closeModal}}):_vm._e(),_vm._v(" "),(_vm.actionSettings)?_c('role-access-configuration',{attrs:{"code-company":_vm.codeCompany,"code-project":_vm.codeProject,"id":_vm.id,"rows":_vm.rowSelect},on:{"close-modal":_vm.closeModal}}):_vm._e(),_vm._v(" "),(_vm.actionSubresources)?_c('role-access-subresource-form',{attrs:{"loading":_vm.subresourceLoading,"modules-id":_vm.modulesId,"resource-id":_vm.resourceId,"resource-name":_vm.resourceName},on:{"close-modal":_vm.closeModal,"send-selection":_vm.assignSubresources}}):_vm._e(),_vm._v(" "),(_vm.actionAssignActionBar)?_c('role-access-action',{attrs:{"resource-id":_vm.resourceId,"code-project":_vm.codeProject,"resource-name":_vm.resourceName,"role-id":_vm.roleId},on:{"close-modal":_vm.closeModal}}):_vm._e(),_vm._v(" "),(_vm.actionServices)?_c('role-access-services',{attrs:{"resource-id":_vm.resourceId,"resource-name":_vm.resourceName,"resource-permission":_vm.resourcePermission,"role-id":_vm.roleId},on:{"save-services":_vm.saveServices,"close-modal":_vm.closeModalServices}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/23.4a6b28f33007889faf3e.js